import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackSlateDesignSystemUiModalShowView } from "@faire/web-api--source/events/slateDesignSystem/view/uiModalShow";
import { useCallback, useEffect, useRef } from "react";

export const useTrackModalEvent = (
  isOpen: boolean,
  postEventModalId?: string
) => {
  const postedEvent = useRef(false);

  const postShowModalEvent = useCallback(() => {
    postedEvent.current = true;
    if (postEventModalId) {
      trackEvent(`/ui/modal/show/${postEventModalId}`);
      trackSlateDesignSystemUiModalShowView(postEventModalId);
    }
  }, [postEventModalId]);

  useEffect(() => {
    if (isOpen && !postedEvent.current) {
      postShowModalEvent();
    }
  }, [isOpen, postShowModalEvent]);
};
